import { render, staticRenderFns } from "./DispatcherDashboard.vue?vue&type=template&id=593a24ac&scoped=true"
import script from "./DispatcherDashboard.vue?vue&type=script&lang=js"
export * from "./DispatcherDashboard.vue?vue&type=script&lang=js"
import style0 from "./DispatcherDashboard.vue?vue&type=style&index=0&id=593a24ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a24ac",
  null
  
)

export default component.exports